import RequestAbstract from "./RequestAbstract";

export default class ClientNotes extends RequestAbstract {
    get link() {
        return this.links.clientNotes;
    }

    async getAllForClient(clientId) {
        const arr = [
            { field: "clientId", op: "=", value: clientId },
        ];

        return this.getAllFiltered([arr], this.getSortField(["-createdTime"]));
    }
}
